const PRIMARY_COLOR = "#57C0A1";

export { PRIMARY_COLOR };
